var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"measures-table"},[_c('div',{staticClass:"measures-table-content"},[_c('hot-table',{ref:"tableComponent",class:_vm.className,style:(_vm.style),attrs:{"settings":_vm.settings}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }